var render, staticRenderFns
import script from "./mySubmit.vue?vue&type=script&lang=js&"
export * from "./mySubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a21117a",
  null
  
)

export default component.exports